import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import MeetingScheduler from './pages/MeetingScheduler';
import WeeklyModule from './pages/WeeklyModule';
import Profile from './pages/Profile';
import PrayerRequests from './pages/PrayerRequests';
import Auth from './pages/Auth';
import { useAuth } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';

function AppShell() {
  const { user, profile, loading, refetchProfile } = useAuth();
  const [userRole, setUserRole] = useState('leader');

  React.useEffect(() => {
    if (profile?.role) setUserRole(profile.role);
  }, [profile]);

  if (loading) {
    return (
      <div className="min-h-screen bg-secondary dark:bg-gray-900 flex items-center justify-center transition-colors duration-200">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 dark:text-gray-400 text-sm">Loading DisciplePath…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Auth onAuth={refetchProfile} />;
  }

  return (
    <div className="min-h-screen bg-secondary dark:bg-gray-900 font-inter transition-colors duration-200">
      <Navigation userRole={userRole} setUserRole={setUserRole} />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="pt-16"
      >
        <Routes>
          <Route path="/" element={<Dashboard userRole={userRole} />} />
          <Route path="/meetings" element={<MeetingScheduler userRole={userRole} />} />
          <Route path="/week/:weekNumber" element={<WeeklyModule userRole={userRole} />} />
          <Route path="/prayers" element={<PrayerRequests userRole={userRole} />} />
          <Route path="/profile" element={<Profile userRole={userRole} setUserRole={setUserRole} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </motion.main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppShell />
      </Router>
    </ThemeProvider>
  );
}

export default App;